<nav class="flex h-full w-full flex-col overflow-hidden bg-surface text-ink-muted">

  <!-- Marca + colapsar -->
  <div class="flex h-16 shrink-0 items-center"
    [ngClass]="collapsed ? 'flex-col justify-center gap-1.5 py-2' : 'justify-between px-4'">

    <!-- Expandido: wordmark + botón colapsar -->
    <ng-container *ngIf="!collapsed">
      <a routerLink="/" class="inline-flex items-center" aria-label="Ir al inicio">
        <img src="assets/img/portal/nuevo-Rayo-logo-columna-izq.webp" class="h-7 w-auto" alt="Rayo" />
      </a>
      <button type="button" (click)="onToggleCollapse()" aria-label="Colapsar menú"
        class="grid h-8 w-8 place-items-center rounded-md text-ink-faint transition-colors hover:bg-ink/5 hover:text-ink cursor-pointer">
        <i class="pi pi-angle-double-left text-sm"></i>
      </button>
    </ng-container>

    <!-- Colapsado: botón expandir + isotipo -->
    <ng-container *ngIf="collapsed">
      <button type="button" (click)="onToggleCollapse()" aria-label="Expandir menú"
        pTooltip="Expandir" tooltipPosition="right"
        class="grid h-8 w-8 place-items-center rounded-md text-ink-faint transition-colors hover:bg-ink/5 hover:text-ink cursor-pointer">
        <i class="pi pi-angle-double-right text-base"></i>
      </button>
      <a routerLink="/" class="grid h-8 w-8 place-items-center" aria-label="Ir al inicio">
        <img src="assets/img/portal/logo_rayo_inicial.png" class="h-7 w-7 object-contain" alt="Rayo" />
      </a>
    </ng-container>
  </div>

  <div class="mx-3 border-t border-line"></div>

  <!-- Secciones -->
  <div class="nav-scroll flex-1 overflow-y-auto overflow-x-hidden px-3 py-2">
    <div *ngFor="let section of (sections$ | async) ?? []; let first = index">
      <p *ngIf="!collapsed"
        class="px-3 pb-1 pt-4 text-[0.66rem] font-semibold uppercase tracking-[0.12em] text-ink-faint">
        {{ section.label }}
      </p>
      <div *ngIf="collapsed && first > 0" class="mx-auto my-2 h-px w-6 bg-line"></div>

      <ul class="m-0 flex list-none flex-col gap-0.5 p-0" [class.pt-2]="collapsed && first === 0">
        <li *ngFor="let item of section.items">
          <ng-container *ngIf="item.variant === 'pill'; else navRow">
            <a *ngIf="!collapsed" [href]="item.external" target="_blank" rel="noopener noreferrer"
              class="mx-auto mt-2 block w-full max-w-[190px]">
              <img src="assets/img/portal/pastilla-pagar.png" [alt]="item.label" class="h-auto w-full" />
            </a>
            <a *ngIf="collapsed" [href]="item.external" target="_blank" rel="noopener noreferrer"
              [pTooltip]="item.label" tooltipPosition="right"
              class="mt-3 flex items-center justify-center rounded-md px-0 py-2.5 text-ink-muted transition-colors hover:bg-ink/5 hover:text-ink">
              <i class="{{ item.icon }} w-5 text-center text-[1.05rem]"></i>
            </a>
          </ng-container>
          <ng-template #navRow>
            <a (click)="onNavigate(item)"
              [pTooltip]="collapsed ? item.label : ''" tooltipPosition="right"
              class="group relative flex cursor-pointer items-center rounded-md text-sm transition-colors"
              [ngClass]="[
                collapsed ? 'justify-center px-0 py-2.5' : 'gap-3 px-3 py-2',
                portalNav.isActive(item, section.items)
                  ? 'bg-ink/[0.06] font-semibold text-ink'
                  : 'font-medium text-ink-muted hover:bg-ink/5 hover:text-ink'
              ]">
              <span *ngIf="portalNav.isActive(item, section.items) && !collapsed"
                class="absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-full bg-rayo-coral"></span>
              <i class="{{ item.icon }} w-5 text-center text-[1.05rem] transition-colors"
                [ngClass]="portalNav.isActive(item, section.items) ? 'text-rayo-coral' : 'text-ink-faint group-hover:text-ink'"></i>
              <span *ngIf="!collapsed">{{ item.label }}</span>
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>

  <!-- Toggle de tema claro/oscuro -->
  <div class="shrink-0 px-3 pt-2">
    <div class="mx-1 mb-2 border-t border-line"></div>
    <button type="button" (click)="theme.toggle()"
      [pTooltip]="collapsed ? ((theme.theme$ | async) === 'dark' ? 'Modo claro' : 'Modo oscuro') : ''" tooltipPosition="right"
      class="flex w-full items-center rounded-md text-ink-muted transition-colors hover:bg-ink/5 hover:text-ink cursor-pointer"
      [ngClass]="collapsed ? 'justify-center p-2' : 'gap-3 px-3 py-2'">
      <i class="w-5 text-center text-[1.05rem]" [ngClass]="(theme.theme$ | async) === 'dark' ? 'pi pi-sun' : 'pi pi-moon'"></i>
      <span *ngIf="!collapsed" class="text-sm font-medium">
        {{ (theme.theme$ | async) === 'dark' ? 'Modo claro' : 'Modo oscuro' }}
      </span>
    </button>
  </div>

  <!-- Tarjeta de usuario -->
  <div class="shrink-0 px-3 pb-3 pt-2" *ngIf="user$ | async as user">
    <div class="mx-1 mb-2 border-t border-line"></div>

    <button #userTrigger="cdkOverlayOrigin" cdkOverlayOrigin type="button" (click)="menuOpen = !menuOpen"
      [pTooltip]="collapsed ? user.nombre : ''" tooltipPosition="right"
      class="flex w-full items-center rounded-md transition-colors hover:bg-ink/5 cursor-pointer"
      [ngClass]="collapsed ? 'justify-center p-1.5' : 'gap-3 p-2'">
      <img [src]="user.avatarUrl" alt="" class="h-9 w-9 shrink-0 rounded-full object-cover"
        (error)="$any($event.target).src = 'assets/img/portal/avatar-default-rayo.png'" />
      <span *ngIf="!collapsed" class="min-w-0 flex-1 text-left">
        <span class="block truncate text-sm font-semibold text-ink">{{ user.nombre }}</span>
        <span *ngIf="user.email" class="block truncate text-xs text-ink-faint">{{ user.email }}</span>
      </span>
      <i *ngIf="!collapsed" class="pi pi-angle-up text-xs text-ink-faint transition-transform"
        [class.rotate-180]="menuOpen"></i>
    </button>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="userTrigger"
      [cdkConnectedOverlayOpen]="menuOpen" [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayWidth]="collapsed ? 232 : userTrigger.elementRef.nativeElement.offsetWidth"
      (overlayOutsideClick)="menuOpen = false" (detach)="menuOpen = false">
      <div class="w-full overflow-hidden rounded-lg border border-line bg-surface py-1 shadow-lg shadow-black/10">
        <div class="border-b border-line px-3 py-2.5">
          <span class="block truncate text-sm font-semibold text-ink">{{ user.nombre }}</span>
          <span *ngIf="user.email" class="block truncate text-xs text-ink-faint">{{ user.email }}</span>
        </div>
        <a *ngFor="let item of userMenu" (click)="onNavigate(item)"
          class="flex cursor-pointer items-center gap-3 px-3 py-2.5 text-sm transition-colors"
          [ngClass]="item.action === 'logout'
            ? 'font-medium text-red-500 hover:bg-red-500/10'
            : 'text-ink-muted hover:bg-ink/5 hover:text-ink'">
          <i class="{{ item.icon }} w-4 text-center text-[0.95rem]"
            [ngClass]="item.action === 'logout' ? 'text-red-500' : 'text-ink-faint'"></i>
          <span>{{ item.label }}</span>
        </a>
      </div>
    </ng-template>
  </div>

</nav>
